import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Upload } from "lucide-react";
import { useT } from "@/lib/LanguageContext";

const IMAGE_FIELDS = [
  ["logo_url", "brand.logoLabel"],
  ["hero_image_url", "brand.heroLabel"],
];

export default function ImagesCard({ branding, setBranding, onUpload }) {
  const t = useT("admin");
  return (
    <div className="bg-white rounded-2xl border border-eh-border-soft p-6">
      <h2 className="font-display text-xl mb-4">{t("brand.images")}</h2>
      <div className="grid sm:grid-cols-2 gap-5">
        {IMAGE_FIELDS.map(([key, labelKey]) => (
          <div key={key}>
            <Label className="text-xs">{t(labelKey)}</Label>
            <div className="mt-2 border-2 border-dashed border-eh-border-soft rounded-xl p-4 text-center hover:bg-eh-cream/30 transition">
              {branding[key] ? (
                <div className="space-y-2">
                  <img src={branding[key]} alt="" className="max-h-24 mx-auto rounded" />
                  <button
                    onClick={() => setBranding({ ...branding, [key]: "" })}
                    className="text-xs text-rose-500 hover:underline"
                  >
                    {t("brand.remove")}
                  </button>
                </div>
              ) : (
                <label className="cursor-pointer block">
                  <input type="file" accept="image/*" className="hidden" onChange={(e) => onUpload(e, key)} data-testid={`upload-${key}`} />
                  <Upload className="w-6 h-6 mx-auto text-eh-muted mb-2" />
                  <div className="text-xs text-eh-muted">{t("brand.clickUpload")}</div>
                </label>
              )}
            </div>
            <Input
              value={branding[key] || ""}
              onChange={(e) => setBranding({ ...branding, [key]: e.target.value })}
              placeholder={t("brand.orPasteUrl")}
              className="mt-2 text-xs"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
